import { render, staticRenderFns } from "./jdsh.vue?vue&type=template&id=1bd681b1&scoped=true&"
import script from "./jdsh.vue?vue&type=script&lang=js&"
export * from "./jdsh.vue?vue&type=script&lang=js&"
import style0 from "./jdsh.vue?vue&type=style&index=0&id=1bd681b1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd681b1",
  null
  
)

export default component.exports